module.exports = __webpack_public_path__ + "img/phone.96161015.webp";